import { Types as HistoryTypes } from '../../../actions/device/history'
import { Types as HistoryNotesTypes } from '../../../actions/device/history/notes'
import { ArrayUtils } from '../../../utils'
import { formatHistory, formatHistoryNotes } from './helpers'

const initialState = {
    history: [],
    isWorking: false,
    isNotesWorking: false,
}

export default (state = initialState, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case HistoryTypes.DEVICE_HISTORY_FETCH.request: {
            return {
                ...state,
                isWorking: true,
            }
        }
        case HistoryTypes.DEVICE_HISTORY_FETCH.success: {
            return {
                ...state,
                history: (payload || []).map(formatHistory),
                isWorking: false,
            }
        }
        case HistoryTypes.DEVICE_HISTORY_FETCH.failure: {
            return {
                ...state,
                isWorking: false,
            }
        }
        case HistoryNotesTypes.DEVICE_HISTORY_NOTES_STORE.request: {
            return {
                ...state,
                isNotesWorking: true,
            }
        }
        case HistoryNotesTypes.DEVICE_HISTORY_NOTES_STORE.failure: {
            return {
                ...state,
                isNotesWorking: false,
            }
        }
        case HistoryNotesTypes.DEVICE_HISTORY_NOTES_STORE.success: {
            const { historyId, parentId } = meta
            // Find the index of history being edited
            const historyItemIndex = state.history.findIndex(({ id }) => id === historyId)

            // No history found
            if (!historyItemIndex === -1) {
                return {
                    ...state,
                    isNotesWorking: false,
                }
            }

            // Get the history instance
            const historyItem = state.history[historyItemIndex]

            // Get the notes
            const { notes: historyNotes } = historyItem

            // Get the updated history instance:
            // If the parent id is specified, a children of that note has been added
            // elsewhere, it's a root note added at the begining of all notes
            let updatedHistoryItem

            if (parentId) {
                // Get parent note from all notes array
                const parentNoteIndex = historyNotes.findIndex(({ id }) => id === parentId)

                // Not found
                if (parentNoteIndex === -1) {
                    return {
                        ...state,
                        isNotesWorking: false,
                    }
                }

                // Parent note instance
                const parentNote = historyNotes[parentNoteIndex]
                // Get children notes
                const { children = [] } = parentNote
                // Build new children notes array
                const newParentChildren = [formatHistoryNotes({ ...payload }), ...children]
                // Add the new children array to the new parent note
                const newParentNote = {
                    ...parentNote,
                    children: newParentChildren,
                }

                // All new parent note into the notes array
                updatedHistoryItem = {
                    ...historyItem,
                    notes: newParentNote,
                }
            } else {
                // Add the new note to the beginning of the history notes array
                updatedHistoryItem = {
                    ...historyItem,
                    notes: [formatHistoryNotes({ ...payload }), ...historyNotes],
                }
            }

            // Add the updated history array into the history item
            const newHistory = ArrayUtils.insertItem(state.history, historyItemIndex, updatedHistoryItem)

            return {
                ...state,
                history: newHistory,
                isWorking: false,
            }
        }
        default:
            return state
    }
}

/**
 * Get selected device history
 * @param {Object} state
 */
const getDeviceHistory = (state) => state.device.history.history

/**
 * Is device history being loaded
 * @param {Object} state
 */
const isHistoryWorking = (state) => state.device.history.isWorking

export { getDeviceHistory, initialState, isHistoryWorking }
